import React from "react";
import Button from "@amzn/awsui-components-react/polaris/button";
import EllipsisText from "./EllipsisText";
import "./EllipsisText.css";

/** One download button, icon plus the truncated file name; greyed when `disabled`, for a task with no file. */
export default function FileDownloadButton({fileName, fallback = "File", disabled = false, loading = false, loadingText, onClick}) {
    return (
        <span className="fileDownloadCell">
            <Button className="fileDownloadButton" iconName="download" variant="inline-link"
                    disabled={disabled} loading={loading} loadingText={loadingText}
                    onClick={disabled || loading ? undefined : onClick}>
                <EllipsisText text={fileName} fallback={fallback} />
            </Button>
        </span>
    );
}
